<template>
  <div class="admin-page">
    <!-- 密码验证 -->
    <div v-if="!authenticated" class="admin-login">
      <div class="admin-login__card">
        <!-- <h2 class="admin-login__title">后台管理</h2> -->
        <!-- <p class="admin-login__desc">请输入访问密码</p> -->
        <div class="admin-login__input-wrap">
          <input
            v-model="password"
            type="password"
            placeholder=""
            class="admin-login__input"
            @keyup.enter="handleLogin"
          />
          <button class="admin-login__btn" @click="handleLogin">進入</button>
        </div>
        <p v-if="loginError" class="admin-login__error">異常 ，請重試</p>
      </div>
    </div>

    <!-- 后台内容 -->
    <div v-else class="admin-content">
      <div class="admin-header">
        <h1 class="admin-header__title">
          {{ activeTab === 0 ? '培訓報名列表' : activeTab === 1 ? '作品列表' : '入圍作品列表' }}
        </h1>
        <div class="admin-header__actions">
          <span class="admin-header__count">共 {{ currentList.length }} 條記錄</span>
          <button class="admin-header__btn" @click="fetchCurrentList" :disabled="loading">
            {{ loading ? '加載中...' : '刷新' }}
          </button>
        </div>
      </div>

      <!-- Tab 栏 -->
      <div class="admin-tabs">
        <div class="admin-tab" :class="{ 'admin-tab--active': activeTab === 0 }" @click="switchTab(0)">培訓報名</div>
        <div class="admin-tab" :class="{ 'admin-tab--active': activeTab === 1 }" @click="switchTab(1)">作品列表</div>
        <div class="admin-tab" :class="{ 'admin-tab--active': activeTab === 2 }" @click="switchTab(2)">入圍作品</div>
      </div>

      <!-- 入围作品分组筛选 -->
      <div v-if="activeTab === 2" class="admin-subtabs">
        <div
          v-for="g in shortlistGroupOptions"
          :key="g.key"
          class="admin-subtab"
          :class="{ 'admin-subtab--active': shortlistGroup === g.key }"
          @click="shortlistGroup = g.key"
        >
          {{ g.label }}
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading && currentList.length === 0" class="admin-loading">
        <i class="el-icon-loading" style="font-size: 24px; margin-right: 8px"></i>
        正在加載數據...
      </div>

      <!-- 空状态 -->
      <div v-else-if="currentList.length === 0" class="admin-empty">
        {{ activeTab === 0 ? '暫無報名數據' : activeTab === 1 ? '暫無作品數據' : '暫無入圍作品' }}
      </div>

      <!-- 培訓報名表格 -->
      <div v-else-if="activeTab === 0" class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th>#</th>
              <th>姓名</th>
              <th>電話</th>
              <th>電郵</th>
              <th>培訓類型</th>
              <th>Token</th>
              <th>是否收集個人資料</th>
              <th>提交時間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in trainingList" :key="idx">
              <td>{{ idx + 1 }}</td>
              <td>{{ item.surname || '' }} {{ item.name || '' }}</td>
              <td>{{ item.phone || '' }}</td>
              <td>{{ item.email || '' }}</td>
              <td>
                <span
                  class="admin-tag"
                  :class="
                    item.trainingType === 'online'
                      ? 'admin-tag--blue'
                      : item.trainingType === 'offline'
                      ? 'admin-tag--green'
                      : 'admin-tag--gray'
                  "
                >
                  {{ item.trainingType === 'online' ? '線上' : item.trainingType === 'offline' ? '線下' : '-' }}
                </span>
              </td>
              <td>
                <span v-if="item.tokenFlag" class="admin-tag admin-tag--orange">需要</span>
                <span v-else class="admin-tag admin-tag--gray">-</span>
              </td>
              <td>
                <span class="admin-tag">{{ item.privacyConsent == '1' ? '是' : '否' }}</span>
              </td>
              <td>{{ formatTime(item.createTime) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 作品列表表格 -->
      <div v-else-if="activeTab === 1" class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th width="40">#</th>
              <th>姓名</th>
              <th>電話</th>
              <th class="break-word" width="120">電郵</th>
              <th class="break-word" width="150">作品描述</th>
              <th class="nowrap-col">組別</th>
              <th>作品圖片</th>
              <th>作品影片</th>
              <th>提交時間</th>
              <th class="nowrap-col">入圍</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in workList" :key="idx">
              <td>{{ item.id }}</td>
              <td>{{ item.surname || '' }} {{ item.name || '' }} ({{ item.title || '' }})</td>
              <td>{{ item.phone || '' }}</td>
              <td class="break-word">{{ item.email || '' }}</td>
              <td class="break-word">{{ item.description || '-' }}</td>
              <td class="nowrap-col">
                <span class="admin-tag" :class="item.groupName === '學生組' ? 'admin-tag--blue' : 'admin-tag--green'">
                  {{ item.groupName || '-' }}
                </span>
              </td>
              <td>
                <a
                  v-if="item.workImageUrl"
                  :href="item.workImageUrl"
                  target="_blank"
                  class="admin-link w-[100px] object-cover block"
                >
                  <img
                    v-if="item.workImageUrl"
                    :src="item.workImageUrl"
                    alt="作品圖片"
                    class="admin-table__img w-full"
                  />
                </a>
                <span v-else class="admin-tag admin-tag--gray">-</span>
              </td>
              <td>
                <a v-if="item.workMediaUrl" href="javascript:;" class="admin-link w-[200px] object-cover block">
                  <video v-if="item.workMediaUrl" :src="item.workMediaUrl" controls class="admin-table__video w-full" />
                </a>
                <span v-else class="admin-tag admin-tag--gray">-</span>
              </td>
              <td>{{ formatTime(item.createTime) }}</td>
              <td class="nowrap-col">
                <el-checkbox
                  :value="item.status === 1 || item.status === '1'"
                  @change="(val) => toggleStatus(item, val)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 作品入围列表表格 status  = 1时 -->
      <div v-else-if="activeTab === 2" class="admin-table-wrap">
        <table class="admin-table">
          <thead>
            <tr>
              <th width="40">#</th>
              <th>姓名</th>
              <th class="nowrap-col">組別</th>
              <th class="break-word" width="150">作品描述</th>
              <th>作品圖片</th>
              <th>作品影片</th>
              <th>提交時間</th>
              <th class="nowrap-col">排名</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in filteredShortlist" :key="item.id || idx">
              <td>{{ item.id }}</td>
              <td>{{ item.surname || '' }} {{ item.name || '' }} ({{ item.title || '' }})</td>
              <td class="nowrap-col">
                <span class="admin-tag" :class="item.groupName === '學生組' ? 'admin-tag--blue' : 'admin-tag--green'">
                  {{ item.groupName || '-' }}
                </span>
              </td>
              <td class="break-word">{{ item.description || '-' }}</td>
              <td>
                <a
                  v-if="item.workImageUrl"
                  :href="item.workImageUrl"
                  target="_blank"
                  class="admin-link w-[100px] object-cover block"
                >
                  <img :src="item.workImageUrl" alt="作品圖片" class="admin-table__img w-full" />
                </a>
                <span v-else class="admin-tag admin-tag--gray">-</span>
              </td>
              <td>
                <a v-if="item.workMediaUrl" href="javascript:;" class="admin-link w-[200px] object-cover block">
                  <video :src="item.workMediaUrl" controls class="admin-table__video w-full" />
                </a>
                <span v-else class="admin-tag admin-tag--gray">-</span>
              </td>
              <td>{{ formatTime(item.createTime) }}</td>
              <td class="nowrap-col">
                <el-select
                  :value="item.ranking || '0'"
                  size="mini"
                  style="width: 90px"
                  :class="rankingClass(item.ranking)"
                  @change="(val) => updateRanking(item, val)"
                >
                  <el-option v-for="opt in rankingOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
                </el-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { customerTrainingListApi, customerWorkListApi, workUpdateStatusApi } from '@/Api/requestApi'

export default {
  name: 'AdminView',
  data() {
    return {
      password: '',
      authenticated: false,
      loginError: false,
      TOKEN_KEY: 'admin_auth_token',
      TOKEN_TTL: 12 * 60 * 60 * 1000, // 12小时
      activeTab: 0,
      trainingList: [],
      workList: [],
      shortlistList: [],
      shortlistGroup: '學生組',
      shortlistGroupOptions: [
        // { key: 'all', label: '全部' },
        { key: '學生組', label: '學生組' },
        { key: '公開組', label: '公開組' },
      ],
      rankingOptions: [
        { value: '0', label: '無' },
        { value: 1, label: '冠軍' },
        { value: 2, label: '亞軍' },
        { value: 3, label: '季軍' },
        { value: 4, label: '優異獎' },
      ],
      loading: false,
    }
  },
  computed: {
    currentList() {
      if (this.activeTab === 0) return this.trainingList
      if (this.activeTab === 1) return this.workList
      return this.filteredShortlist
    },
    filteredShortlist() {
      if (this.shortlistGroup === 'all') return this.shortlistList
      return this.shortlistList.filter((item) => item.groupName === this.shortlistGroup)
    },
  },
  mounted() {
    this.checkToken()
  },
  methods: {
    handleLogin() {
      if (this.password === 'klm8888') {
        this.authenticated = true
        this.loginError = false
        this.saveToken()
        this.fetchCurrentList()
      } else {
        this.loginError = true
      }
    },
    saveToken() {
      const data = { loginTime: Date.now() }
      localStorage.setItem(this.TOKEN_KEY, JSON.stringify(data))
    },
    checkToken() {
      try {
        const raw = localStorage.getItem(this.TOKEN_KEY)
        if (!raw) return
        const data = JSON.parse(raw)
        if (Date.now() - data.loginTime < this.TOKEN_TTL) {
          this.authenticated = true
          this.fetchCurrentList()
        } else {
          this.logout()
        }
      } catch {
        this.logout()
      }
    },
    logout() {
      localStorage.removeItem(this.TOKEN_KEY)
      this.authenticated = false
    },
    switchTab(tab) {
      this.activeTab = tab
      if (this.currentList.length === 0) {
        this.fetchCurrentList()
      }
    },
    async fetchCurrentList() {
      if (this.activeTab === 0) {
        await this.fetchTrainingList()
      } else if (this.activeTab === 1) {
        await this.fetchWorkList()
      } else {
        await this.fetchShortlistList()
      }
    },
    async fetchTrainingList() {
      this.loading = true
      try {
        const res = await customerTrainingListApi({})
        console.log('trainingList :>> ', res)
        this.trainingList = res.data?.data || res.data?.rows || []
      } catch (err) {
        console.error('fetchTrainingList error :>> ', err)
        this.$message.error('獲取培訓數據失敗')
      } finally {
        this.loading = false
      }
    },
    async fetchWorkList() {
      this.loading = true
      try {
        const res = await customerWorkListApi({})
        console.log('workList :>> ', res)
        this.workList = res.data?.data || res.data?.rows || []
      } catch (err) {
        console.error('fetchWorkList error :>> ', err)
        this.$message.error('獲取作品數據失敗')
      } finally {
        this.loading = false
      }
    },
    async fetchShortlistList() {
      this.loading = true
      try {
        const res = await customerWorkListApi({ status: 1 })
        console.log('shortlistList :>> ', res)
        this.shortlistList = (res.data?.data || res.data?.rows || []).map((it) => ({
          ...it,
          ranking: Number(it.ranking) || 0,
        }))
      } catch (err) {
        console.error('fetchShortlistList error :>> ', err)
        this.$message.error('獲取入圍作品數據失敗')
      } finally {
        this.loading = false
      }
    },
    formatTime(t) {
      if (!t) return '-'
      const d = new Date(t)
      if (isNaN(d.getTime())) return t
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
        d.getMinutes()
      )}`
    },
    rankingClass(ranking) {
      return ranking ? `ranking-${ranking}` : ''
    },
    async updateRanking(item, val) {
      console.log('updateRanking :>> ', item, val)
      const ranking = Number(val) || '0'
      try {
        const res = await workUpdateStatusApi({ id: item.id, ranking })
        if (res.data.code === 200) {
          item.ranking = ranking
          this.$message.success(ranking ? '已更新排名' : '已清除排名')
        } else {
          this.$message.error('更新失敗，請稍後重試')
        }
      } catch {
        this.$message.error('請求失敗，請稍後重試')
      }
    },
    async toggleStatus(item, val) {
      const newStatus = val ? 1 : 0
      item.status = newStatus
      try {
        const res = await workUpdateStatusApi({ id: item.id, status: newStatus })
        if (res.data.code === 200) {
          item.status = newStatus
          this.$message.success(val ? '已設為入圍' : '已取消入圍')
          // 同步刷新入圍列表
          if (this.shortlistList.length || this.activeTab === 2) {
            this.fetchShortlistList()
          }
        } else {
          this.$message.error('更新失敗，請稍後重試')
        }
      } catch {
        this.$message.error('請求失敗，請稍後重試')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.admin-page {
  min-height: 100vh;
  background: #f5f5f5;
}

/* ===== 登录 ===== */
.admin-login {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}
.admin-login__card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 36px;
  width: 360px;
  max-width: 90%;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  text-align: center;
}
.admin-login__title {
  font-size: 24px;
  font-weight: 700;
  color: #222;
  margin-bottom: 8px;
}
.admin-login__desc {
  font-size: 14px;
  color: #999;
  margin-bottom: 28px;
}
.admin-login__input-wrap {
  display: flex;
  gap: 8px;
}
.admin-login__input {
  flex: 1;
  height: 42px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 14px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.3s;
  &:focus {
    border-color: #f54e02;
  }
}
.admin-login__btn {
  height: 42px;
  padding: 0 8px;
  border: none;
  border-radius: 8px;
  background: #f54e02;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.3s;
  &:hover {
    background: #d94400;
  }
}
.admin-login__error {
  margin-top: 14px;
  font-size: 13px;
  color: #e53935;
}

/* ===== 后台内容 ===== */
.admin-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px;
}
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}
.admin-header__title {
  font-size: 22px;
  font-weight: 700;
  color: #222;
}
.admin-header__actions {
  display: flex;
  align-items: center;
  gap: 12px;
}
.admin-header__count {
  font-size: 14px;
  color: #888;
}
.admin-header__btn {
  height: 36px;
  padding: 0 18px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    border-color: #f54e02;
    color: #f54e02;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.admin-loading,
.admin-empty {
  text-align: center;
  padding: 80px 20px;
  font-size: 15px;
  color: #999;
}

/* ===== 表格 ===== */
.admin-table-wrap {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow-x: auto;
}
.admin-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 680px;
}
.admin-table th {
  background: #fafafa;
  padding: 12px 14px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  border-bottom: 1px solid #eee;
}
.nowrap-col {
  white-space: nowrap;
}
.break-word {
  word-break: break-word;
}
.admin-table td {
  padding: 12px 14px;
  font-size: 12px;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
}
.admin-table tr:hover td {
  background: #fafafa;
}

.admin-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}
.admin-tag--blue {
  background: #e3f2fd;
  color: #1976d2;
}
.admin-tag--green {
  background: #e8f5e9;
  color: #388e3c;
}
.admin-tag--orange {
  background: #fff3e0;
  color: #e65100;
}
.admin-tag--gray {
  background: #f5f5f5;
  color: #bbb;
}

/* ===== 排名选择框上色 ===== */
.ranking-1 ::v-deep .el-input__inner {
  background: #ec950c;
  color: #fff;
  border-color: #ec950c;
}
.ranking-2 ::v-deep .el-input__inner {
  background: #383838;
  color: #fff;
  border-color: #383838;
}
.ranking-3 ::v-deep .el-input__inner {
  background: #9d440a;
  color: #fff;
  border-color: #9d440a;
}
.ranking-4 ::v-deep .el-input__inner {
  background: #064eae;
  color: #fff;
  border-color: #064eae;
}

/* ===== 入围分组筛选 ===== */
.admin-subtabs {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.admin-subtab {
  padding: 6px 18px;
  border: 1px solid #ddd;
  border-radius: 16px;
  background: #fff;
  font-size: 13px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    border-color: #f54e02;
    color: #f54e02;
  }
}
.admin-subtab--active {
  background: #f54e02;
  border-color: #f54e02;
  color: #fff;
  &:hover {
    color: #fff;
  }
}

/* ===== Tab 栏 ===== */
.admin-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 20px;
  border-bottom: 2px solid #eee;
}

/* ===== 入围复选框放大 ===== */
.nowrap-col ::v-deep .el-checkbox__inner {
  width: 25px !important;
  height: 25px !important;
}
.nowrap-col ::v-deep .el-checkbox__inner::after {
  left: 9px !important;
  top: 5px !important;
  width: 4px;
  height: 9px;
  border: 3px solid #fff;
  content: '';
  border-left: 0;
  border-top: 0;
}
.nowrap-col ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: rgb(221, 11, 46);
  border-color: rgb(221, 11, 46);
}
.admin-tab {
  padding: 10px 24px;
  font-size: 15px;
  font-weight: 600;
  color: #888;
  cursor: pointer;
  position: relative;
  transition: color 0.3s;
  user-select: none;
}
.admin-tab:hover {
  color: #f54e02;
}
.admin-tab--active {
  color: #f54e02;
}
.admin-tab--active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: #f54e02;
  border-radius: 2px 2px 0 0;
}

/* ===== 链接 ===== */
.admin-link {
  color: #f54e02;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
}
</style>
